var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,12.5c0,2.48-2.02,4.5-4.5,4.5h-4.5v-2h4.5c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5h-6.5v2h-1l-3-3,3-3h1v2h6.5c2.48,0,4.5,2.02,4.5,4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/1765206080/media/icon-undo.f22966080fd02cfb624ed252ca9d3311.svg";
export { ForwardRef as ReactComponent };